import Vue from 'vue'
import VueRouter from 'vue-router'


import FormViewRun from '@/views/Cop/FormViewRun.vue'
import FormViewRunEdit from '@/views/FormViewRunEdit.vue'
import OutFormViewRun from '@/views/OutFormViewRun.vue'
import InFormViewRun from '@/views/kullanici/InFormViewRun.vue'
import Formlar from '@/views/FormListesi.vue'
import KullaniciFormListesi from '@/views/kullanici/KullaniciFormListesi.vue'
import KullaniciDegerlendirilecekFormListesi from '@/views/KullaniciDegerlendirilecekFormListesi.vue'
import LoginPage from '@/views/Login.vue'
import KullaniciLogin from '@/views/kullanici/KullaniciLogin.vue'
import FormSavedSuccess from '@/views/FormSavedSuccess.vue'
import FormEdit from '@/views/FormEdit.vue'
import FormResultDataView from '@/views/FormResultDataView.vue'
import KullaniciFormResultDataView from '@/components/KullaniciFormResultDataView.vue'
import KullaniciEbeFormResultDataView from '@/components/KullaniciEbeFormResultDataView.vue'
// import AdminLog from '@/views/AdminLog.vue'
import FormRapor from '@/views/FormRapor.vue'
import KullaniciDashboard from '@/views/kullanici/KullaniciDashboard.vue'
import UnAuthorized from '@/views/UnAuthorized.vue'
import AdminFormOnGosterim from '@/views/AdminFormOnGosterim.vue'
import AnketRapor from '@/views/AnketRapor.vue'
import AnketDashboard from '@/views/AnketDashboard.vue'
import AktifAnketler from '@/views/AktifAnketler.vue'
import YoneticiCRUD from '@/views/YoneticiCRUD.vue'
Vue.use(VueRouter)

const routes = [

  {
    name: "Login", path: '/login', component: LoginPage, meta: { requiresAuth: false },

  },
  {
    name: "AktifAnketler", path: '/ankets', component: AktifAnketler, meta: { requiresAuth: false },

  },
  {
    name: "KullaniciLogin", path: '/login/:id', component: KullaniciLogin, meta: { requiresAuth: false },

  },
  {
    name: "FormSavedSuccess", path: '/success', component: FormSavedSuccess, meta: { requiresAuth: false },

  },
  {
    name: "OutFormViewRun", path: '/formview/:id', component: OutFormViewRun, meta: { requiresAuth: false },

  },
  // {
  //   name: "Login", path: '/login', component: Login, meta: {  requiresAuth: false  },

  // },

  {
    path: '/',
    redirect: '/login',
    component: () => import('@/layouts/MainView'),
    children: [
            {
        path: "/yoneticiler",
        name: "YoneticiYonetimi",
        component: () => import("@/views/YoneticiCRUD.vue")
      },
      {
        path: "/unauthorized",
        name: "UnAuthorized",
        component: () => import("@/views/UnAuthorized.vue")
      },
      {
        name: "anketRapor", path: 'anketrapor/:id', component: AnketRapor, meta: { requiresAuth: false },

      },

      {
        path: 'kullaniciDegerlendirilecekformlistesi',
        name: 'KullaniciDegerlendirilecekFormlistesi',
        component: KullaniciDegerlendirilecekFormListesi,
        meta: {
          requiresAuth: true // Add meta field to indicate protected route
        }
      },

      {
        path: 'kullaniciformlistesi',
        name: 'KullaniciFormListesi',
        component: KullaniciFormListesi,
        meta: {
          permission: "kullanici",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      //        {
      //   path: 'adminLog',
      //   name: 'AdminLog',
      //   component: AdminLog,
      //   meta: {
      //               permission: "kullanici",
      //     requiresAuth: true // Add meta field to indicate protected route
      //   }     
      // },

      {
        path: 'formgosterim/:id',
        name: 'formgosterim',
        component: InFormViewRun,
        meta: {

          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      {
        path: 'formgosterimedit/:id',
        name: 'formgosterimedit',
        component: FormViewRunEdit,
        meta: {

          requiresAuth: true // Add meta field to indicate protected route
        }
      },

      {
        path: 'formtasarimi/:id',
        name: 'formtasarimi',
        component: FormEdit,
        meta: {
          permission: "admin",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },

      {
        path: 'formlar',
        name: 'formlar',
        component: Formlar,
        meta: {
          permission: "admin",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      {
        path: 'anketDashbord',
        name: 'anketDashbord',
        component: AnketDashboard,
        meta: {
          permission: "admin",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      {
        path: 'rapor',
        name: 'rapor',
        component: FormRapor,
        meta: {
          permission: "admin",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      {
        path: 'formdata/:id',
        name: 'formdata',
        component: FormResultDataView,
        meta: {
          permission: "admin",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      {
        path: 'kullaniciformdata/:id',
        name: 'KullaniciFormData',
        component: KullaniciFormResultDataView,
        meta: {
          permission: "kullanici",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
         {
        path: 'ebereport/:id',
        name: 'EbeFormReport',
        component: KullaniciEbeFormResultDataView,
        meta: {
          permission: "kullanici",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },
      {
        path: 'adminformonizleme/:id',
        name: 'AdminFormOnGosterim',
        component: AdminFormOnGosterim,
        meta: {
          permission: "kullanici",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },

      {
        path: 'kullaniciDashboard/:id',
        name: 'kullaniciDashboard',
        component: KullaniciDashboard,
        meta: {
          permission: "kullanici",
          requiresAuth: true // Add meta field to indicate protected route
        }
      },


      // {
      //   path: '/about',
      //   name: 'about',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
      //   meta: {
      //     requiresAuth: true // Add meta field to indicate protected route
      //   }
      // }



    ]
  },



]
//https://medium.com/@tahnyybelguith/authentication-and-authorization-implementation-with-vue-js-6afcbb821c85
const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes,
  meta: {
    requiresAuth: true // Add meta field to indicate protected route
  }
})


// router.beforeEach((to, from, next) => {
//   const userPermissions = authStore.permissions;
//   const required = to.meta.permission;
//   if (!required || userPermissions.includes(required)) {
//     next();
//   } else {
//     next('/unauthorized');
//   }
// });



// router.beforeEach((to, from, next) => {

// console.log()
//   if (to.matched.some((record) =>{ return record.meta.requiresAuth } )) {
//     // this route requires auth, check if logged in
//     // if not, display guest greeting.

//     //const loggedIn = JSON.parse(localStorage.getItem("loggedIn"));
//     const loggedIn = localStorage.getItem("loggedIn");
//     if (!loggedIn) {
//       next({
//         path: '/login'
//       });
//     } else {
//       next();
//     }
//   } else {
//     next(); // make sure to always call next()!
//   }
// })



// chunk load error handler
router.onError(error => {
  const chunkFailedMessage = /Loading chunk [^\s]+ failed/;
  if (chunkFailedMessage.test(error.message)) {
    console.warn('Chunk yüklemede hata, sayfa yenileniyor…', error);
    window.location.reload();
  }
})


export default router
